import { SERVER_URL } from "../../utils/constants";
import HttpRequest from "../../utils/HttpRequest";

export const completeAppointmentService = async (itemId, data) => {
  return await HttpRequest.update(
    `${SERVER_URL}/appointment/done/${itemId}`,
    data
  );
};

export const createAppointmentService = async (data) => {
  return await HttpRequest.post(`${SERVER_URL}/appointment/add`, data);
};
